import apiPublic from "@/services/apiPublic";

export type RegisterReferralAssociatePayload = {
  referralCode: string;
  name: string;
  phone: string;
  email: string;
  document: string;
};

class RegisterReferralAssociate {
  execute = async (payload: RegisterReferralAssociatePayload) => {
    const response = await apiPublic().post("/referral/register", {
      ...payload,
      document: payload.document.replace(/\D/g, ""),
      phone: payload.phone.replace(/\D/g, ""),
      referralCode: payload.referralCode.trim().toUpperCase(),
    });
    return response.data as { message: string; referrerName: string; franchiseCity: string };
  };
}

export { RegisterReferralAssociate };
